import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ScrollPicker, ScrollPickerGroup } from 'vue-scroll-picker';
import 'vue-scroll-picker/dist/style.css';
export default {
  name: 'FibTimePicker',
  components: {
    ScrollPicker: ScrollPicker,
    ScrollPickerGroup: ScrollPickerGroup
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      scrollSensitivity: 20,
      hourOptions: Array.from(Array(12)).map(function (item, index) {
        var hour = index + 1;
        return hour < 10 ? '0' + hour : String(hour);
      }),
      minOptions: ['00', '15', '30', '45']
    };
  },
  computed: {
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    },
    meridianOptions: function meridianOptions() {
      return [this.$t('checkIn.aboutVisit.am'), this.$t('checkIn.aboutVisit.pm')];
    }
  },
  methods: {
    update: function update(key, value) {
      this.$emit('input', _objectSpread(_objectSpread({}, this.value), {}, _defineProperty({}, key, value)));
    }
  }
};